/*eslint-disable linebreak-style */
import React, { useState } from 'react';
import { Formik } from 'formik';
import { Container, Row, Col, Form, Accordion, Card } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AutoSuggestionSelectComponent from '../../../components/common/AutoSuggestSelect/Select';
import Button from '../../../components/common/button';
import { useSelector, useDispatch } from 'react-redux';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import { useTranslation } from 'react-i18next';

import ToastMessage from '../../../components/common/ToastMessage';
import 'react-toastify/dist/ReactToastify.css';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import { setUserData } from 'src/redux/app/userSlice';

const EditProfileForm = ({
  schema,
  currentStep,
  nextStep,
  userData,
  formData,
  handleInput,
  countryCodeList,
  serverError,
  onSubmitForm,
  onClickCancel,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  //const { userData } = useSelector( state => state?.user );

  let { themeValuesObject } = useSelector((state) =>
    state?.theme?.branding
      ? state?.theme?.branding
      : { themeValuesObject: { 'Secondary-1': '#444444' } },
  );
  if (!themeValuesObject) {
    themeValuesObject = { 'Secondary-1': '#444444' };
  }

  const getUserData = async () => {
    try {
      const response = await axiosInstance.get(
        APIEndpoints.GetUser() + userData.UserID,
      );
      const getUserDataResp = response.data;

      if (HttpSuccessCodes.HTTP_SUCCESS_CODE_200 === response.status) {
        dispatch(setUserData(getUserDataResp.Response.User));
      } else {
        console.log('could not get user 47');
      }
    } catch (error) {
      console.log('could not get user 50');
    }
  };

  const formatPhone = (e) => {
    const target = e.target;
    const input = e.target.value.replace(/\D/g, '').substring(0, 10);
    const first = input.substring(0, 3);
    const middle = input.substring(3, 6);
    const last = input.substring(6, 10);
    if (input.length > 6) {
      target.value = `${first}-${middle}-${last}`;
    } else if (input.length > 3) {
      target.value = `${first}-${middle}`;
    } else if (input.length > 0) {
      target.value = `${first}`;
    }
  };

  if (serverError) {
    return <Navigate to="/admin/server-error" push={true}></Navigate>;
  }
  //return <Container className="account-info-container column-section-left">
  return (
    <div className="profile-information-my-profile">
      <Card className="card-container">
        <div className="top-section">
          <div className="user-icon">
            {userData?.FirstName[0] + userData?.LastName[0]}
          </div>
          <div className="name-email-container">
            <div className="name">{`${userData?.FirstName}${
              userData?.MiddleName ? ' ' + userData?.MiddleName + ' ' : ' '
            }${userData?.LastName}`}</div>
            <div className="email">{userData?.UserID || '-'}</div>
          </div>
          <div className="user-type-data-container">
            <div className="heading">User Type</div>
            <div className="data">
              {userData?.UserType
                ? userData?.UserType === 'Client'
                  ? 'Employer'
                  : userData?.UserType
                : '-'}
            </div>
          </div>
        </div>
        <div className="info-section">
          <div className="heading">
            <Row>
              <Col md={8}>Profile Information</Col>
            </Row>
          </div>
          <Row>
            <Col md={12}>
              <Formik
                validationSchema={schema}
                initialValues={{
                  contactNumber: '',
                  jobTitle: '',
                  address: '',
                  employeeId: '',
                }}
                enableReinitialize
                onSubmit={(values) => {
                  console.log('ACCOUNT INFO VALUES ====>', values);
                  //nextStep();
                  onSubmitForm()
                    .then((res) => {
                      toast.success(
                        <ToastMessage
                          type="success"
                          subTitle="Successfully updated your profile."
                        />,
                      );
                      getUserData();
                      onClickCancel();
                    })
                    .catch((error) => {
                      toast.error(
                        <ToastMessage
                          type="error"
                          subTitle="Error updating your profile."
                        />,
                      );
                    });
                }}
              >
                {({
                  values,
                  touched,
                  errors,
                  status,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  setStatus,
                  setFieldValue,
                  setFieldTouched,
                }) => {
                  return (
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Col>
                          {/*<PersonalInformationViewPanel firstName={firstName} lastName={lastName} userName={userName} userEmail={email} userType={UserType} />*/}
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col sm={6}>
                          <Form.Group className="mb-4">
                            <Form.Label className="mb-0">
                              Contact Number
                            </Form.Label>
                            <div className="d-flex">
                              <div className="countrycode-width">
                                <AutoSuggestionSelectComponent
                                  options={countryCodeList}
                                  name="countryCode"
                                  defaultValue={formData.countryCode}
                                  //placeholder="Select Country Code"
                                  components={{
                                    IndicatorSeparator: () => null,
                                  }}
                                  //value={values.countryCode}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  fieldTouch={setFieldTouched}
                                  isSearchable={false}
                                  inputClassName={
                                    touched.countryCode && errors.countryCode
                                      ? 'select-invalid-error'
                                      : ''
                                  }
                                  isRequired={true}
                                  isInvalid={
                                    touched.countryCode && errors.countryCode
                                  }
                                  isDisabled={true}
                                />
                              </div>
                              <div className="contact-number">
                                <Form.Control
                                  type="text"
                                  name="contactNumber"
                                  placeholder=""
                                  className={
                                    errors && errors.contactNumber
                                      ? 'is-invalid'
                                      : ''
                                  }
                                  value={formData.contactNumber}
                                  isInvalid={errors.contactNumber}
                                  maxLength={12}
                                  onKeyUp={(e) => formatPhone(e)}
                                  onChange={(e) => {
                                    handleInput(e, setFieldValue, handleChange);
                                  }}
                                  onBlur={(e) => {
                                    handleInput(e, setFieldValue, handleChange);
                                  }}
                                />
                                {status && status.contactNumber ? (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className=""
                                  >
                                    <span>{status.contactNumber}</span>
                                  </Form.Control.Feedback>
                                ) : (
                                  errors.contactNumber && (
                                    <Form.Control.Feedback
                                      type="invalid"
                                      className=""
                                    >
                                      <span>{errors.contactNumber}</span>
                                    </Form.Control.Feedback>
                                  )
                                )}
                              </div>
                            </div>
                          </Form.Group>
                        </Col>
                        <Col sm={6}>
                          <Form.Group className="mb-4">
                            <Form.Label className="mb-0">
                              Job Title/Role
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="jobTitle"
                              placeholder=""
                              className={
                                status && status.jobTitle ? 'is-invalid' : ''
                              }
                              value={formData.jobTitle}
                              isInvalid={errors.jobTitle}
                              onChange={(e) => {
                                handleInput(e, setFieldValue, handleChange);
                              }}
                              onBlur={(e) => {
                                handleInput(e, setFieldValue, handleChange);
                              }}
                            />
                            {status && status.jobTitle ? (
                              <Form.Control.Feedback
                                type="invalid"
                                className=""
                              >
                                <span>{status.jobTitle}</span>
                              </Form.Control.Feedback>
                            ) : (
                              errors.jobTitle && (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className=""
                                >
                                  <span>{errors.jobTitle}</span>
                                </Form.Control.Feedback>
                              )
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6}>
                          <Form.Group className="mb-4">
                            <Form.Label className="mb-0">
                              Employee ID
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="employeeId"
                              placeholder=""
                              className={
                                status && status.employeeId ? 'is-invalid' : ''
                              }
                              value={formData.employeeId}
                              isInvalid={errors.employeeId}
                              onChange={(e) => {
                                handleInput(e, setFieldValue, handleChange);
                              }}
                              onBlur={(e) => {
                                handleInput(e, setFieldValue, handleChange);
                              }}
                            />
                            {status && status.employeeId ? (
                              <Form.Control.Feedback
                                type="invalid"
                                className=""
                              >
                                <span>{status.employeeId}</span>
                              </Form.Control.Feedback>
                            ) : (
                              errors.employeeId && (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className=""
                                >
                                  <span>{errors.employeeId}</span>
                                </Form.Control.Feedback>
                              )
                            )}
                          </Form.Group>
                        </Col>
                        <Col sm={6}>
                          <Form.Group className="mb-4">
                            <Form.Label className="mb-0">
                              Location / City / Region
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="address"
                              placeholder=""
                              className={
                                status && status.address ? 'is-invalid' : ''
                              }
                              value={formData.address}
                              isInvalid={errors.address}
                              onChange={(e) => {
                                handleInput(e, setFieldValue, handleChange);
                              }}
                              onBlur={(e) => {
                                handleInput(e, setFieldValue, handleChange);
                              }}
                            />
                            {status && status.address ? (
                              <Form.Control.Feedback
                                type="invalid"
                                className=""
                              >
                                <span>{status.address}</span>
                              </Form.Control.Feedback>
                            ) : (
                              errors.address && (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className=""
                                >
                                  <span>{errors.address}</span>
                                </Form.Control.Feedback>
                              )
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                      <Form.Group
                        className="form-block-1"
                        controlId="buttonsFormGroup"
                      >
                        <Row className="row-border-top">
                          <Col className="d-flex justify-content-end">
                            <GenericButton
                              variant="link"
                              onClick={() => {
                                onClickCancel();
                              }}
                            >
                              <b>{t('label_cancel')}</b>
                            </GenericButton>

                            <GenericButton type="submit">
                              <b>Continue</b>
                            </GenericButton>
                          </Col>
                        </Row>
                      </Form.Group>
                    </Form>
                  );
                }}
              </Formik>
            </Col>
          </Row>
        </div>
      </Card>
    </div>
  );

  //</Container>;
};

export default EditProfileForm;
